export default __webpack_public_path__ + "static/media/teddy.1f3f97ed.obj";